export const isPushSupported = (target = window) =>
  typeof target !== "undefined" &&
  typeof target.Notification !== "undefined" &&
  typeof target.PushManager !== "undefined" &&
  typeof target.serviceWorker !== "undefined";

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = `${base64String}${padding}`
    .replace(/-/g, "+")
    .replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let index = 0; index < rawData.length; index += 1) {
    outputArray[index] = rawData.charCodeAt(index);
  }

  return outputArray;
};

export const registerPushServiceWorker = async ({
  target = navigator,
  serviceWorkerPath = "/push-sw.js",
} = {}) => {
  if (!target?.serviceWorker?.register) {
    return null;
  }

  return target.serviceWorker.register(serviceWorkerPath);
};

export const subscribeToPushNotifications = async ({
  serviceWorkerRegistration,
  vapidPublicKey,
}) => {
  if (
    !serviceWorkerRegistration?.pushManager?.subscribe ||
    !vapidPublicKey
  ) {
    return null;
  }

  return serviceWorkerRegistration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
  });
};
